import styled from 'styled-components';
import {WidgetFooterPhraseFirst} from 'components/WidgetFooter/WidgetFooterPhraseFirst';

export const WidgetFooterPhraseThird = styled(WidgetFooterPhraseFirst)`
  animation-delay: 6s;
`;
